import CameraPage from "./Camera";
import DiscrepanciesPage from "./Discrepancies";
import PenaltyPage from "./Penalty";
import ReservesPage from "./Reserves";
import ReviewsPage from "./Reviews";
import ShipmentPage from "./Shipment";
import WarehousePage from "./Warehouse";

const ControlQualityPages = {
    Camera: CameraPage,
    Discrepancies: DiscrepanciesPage,
    Penalty: PenaltyPage,
    Reserve: ReservesPage,
    Reviews: ReviewsPage,
    Shipment: ShipmentPage,
    Warehouse: WarehousePage,
}

export default ControlQualityPages